export var DOTCOM_CHANNEL_ID = 'd9a5bc42-4b9c-4976-858a-f159cf99c647';
export var SNRKS_WEB_CHANNEL_ID = '010794e5-35fe-4e32-aaff-cd2c74f89d61';
export var APP_NAME = 'CiCCart';